import { Component } from '@angular/core';
import { ReportService } from './services/report.service';
import { GoogleAuthService } from "./google-auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'vna';
  constructor(public rs: ReportService, public gas: GoogleAuthService) { }
  ngOnInit() {
    // this.rs.getTotalFileUsageSizeForClient('b2cxuGqm9XbUNLn0p8NYwgcJ9y03').then((totalSize) => {
    //   console.log(totalSize);
    // });
  }
}
